import { useState } from "react";
import { Search, Plus, HardHat } from "lucide-react";
import { toast } from "sonner";
import { Card, PageHeader, Btn, Segmented, Placeholder, inputCls } from "../ui";

export default function PartnerPros() {
  const [scope, setScope] = useState("all");
  const [q, setQ] = useState("");
  const [trade, setTrade] = useState("Tous");

  return (
    <div data-testid="partner-pros">
      <PageHeader
        eyebrow="Réseau"
        title="Professionnels"
        sub="Retrouvez les entreprises et artisans avec lesquels vous travaillez : membres du réseau CozyHome ou entreprises extérieures que vous invitez."
        actions={
          <Btn testid="pro-invite" onClick={() => toast.info("L'invitation d'une entreprise extérieure sera connectée dans la phase suivante.")}>
            <Plus className="h-4 w-4" /> Inviter une entreprise
          </Btn>
        }
      />

      <Segmented
        testid="pro-scope"
        value={scope}
        onChange={setScope}
        options={[
          { value: "all", label: "Tous" },
          { value: "network", label: "Réseau CozyHome" },
          { value: "external", label: "Extérieurs invités" },
        ]}
      />

      <Card className="mt-4 flex flex-col gap-3 p-3 sm:flex-row">
        <div className="relative flex-1">
          <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-stone-400" />
          <input data-testid="pro-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Rechercher une entreprise, un métier…" className={`${inputCls} pl-9`} />
        </div>
        <select data-testid="pro-filter-trade" value={trade} onChange={(e) => setTrade(e.target.value)} className={`${inputCls} sm:w-56`}>
          <option>Tous</option>
        </select>
      </Card>

      <Card className="mt-4 p-10" testid="pro-list">
        <Placeholder testid="pro-list-empty">
          <HardHat className="mx-auto mb-2 h-6 w-6 text-stone-300" />
          L'annuaire des professionnels du réseau CozyHome n'est pas encore connecté à vos entreprises réelles.
          Cette fonctionnalité arrive dans une prochaine mise à jour.
        </Placeholder>
      </Card>
    </div>
  );
}
